// src/pages/Quote.js
import React, { useState } from "react";
import axios from "axios";
import "./Quote.css";

function Quote() {
  const [formData, setFormData] = useState({
    fullName: "",
    relationship: "",
    phone: "",
    email: "",
    departure: "",
    destination: "",
    medicalInfo: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await axios.post("php/quote.php", formData, {
        headers: { "Content-Type": "application/json" },
      });

      setMessage(response.data.message);
    } catch (error) {
      setMessage("Failed to send request. Please try again.");
    }
  };

  return (
    <div className="quote-container">
      {/* Title */}
      <h1 className="quote-title">
        Request Landscape Services – Greenview San Diego Hardscape
      </h1>

      <p className="quote-subtitle">
        Licensed C-27 Landscape Contractor • CSLB License #1141945
      </p>

      <form onSubmit={handleSubmit} className="quote-form">
        <label>Full Name (Homeowner or Property Manager)</label>
        <input
          type="text"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
          required
        />

        <label>Best Contact Phone Number</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <label>Email Address (optional)</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />

        <label>Select the Type of Service Requested</label>
        <select
          name="relationship"
          value={formData.relationship}
          onChange={handleChange}
          required
        >
          <option value="">-- Please Select --</option>
          <option value="Landscape Design Consultation">
            Landscape Design Consultation
          </option>
          <option value="Hardscape & Concrete Installation">
            Hardscape & Concrete Installation
          </option>
          <option value="Pavers Installation">
            Pavers Installation
          </option>
          <option value="Artificial Turf Installation">
            Artificial Turf Installation
          </option>
          <option value="Irrigation System Installation / Repair">
            Irrigation System Installation / Repair
          </option>
          <option value="Drainage & Grading Solutions">
            Drainage & Grading Solutions
          </option>
          <option value="Clean-Up / Yard Transformation">
            Clean-Up / Yard Transformation
          </option>
          <option value="On-Site Estimate">
            On-Site Estimate / Walk-Through
          </option>
        </select>

        <label>Preferred Date & Time</label>
        <input
          type="datetime-local"
          name="departure"
          value={formData.departure}
          onChange={handleChange}
        />

        <label>Project Address</label>
        <input
          type="text"
          name="destination"
          value={formData.destination}
          onChange={handleChange}
          placeholder="Street address, city, and access notes"
        />

        <label>Project Details</label>
        <textarea
          name="medicalInfo"
          value={formData.medicalInfo}
          onChange={handleChange}
          placeholder="Describe your project: square footage, turf, concrete, pavers, drainage issues, irrigation, or any important notes."
        ></textarea>

        <button type="submit" className="submit-btn">
          Send Request to Greenview San Diego Hardscape
        </button>
      </form>

      {message && <p className="message">{message}</p>}
    </div>
  );
}

export default Quote;